'use client'
import React from 'react'
import Video from '@components/Video'
import { AiFillCloseSquare } from 'react-icons/ai'
import tailwindConfig from '@tailwind.config'



const VideoGallery = ({ isVideoOpen, onVideoClose, videoUrl }) => {
    if (!isVideoOpen) return null;


    return (
        <div className='w-full h-full z-50 fixed left-0 bg-maincolor bg-opacity-70 top-0 overflow-hidden'>
            <div className='relative w-full h-full flex items-center justify-center'>
                <div className='absolute z-50 top-0 right-0'>
                    <button className='p-2' onClick={onVideoClose}>
                        <AiFillCloseSquare
                            color={tailwindConfig.theme.extend.colors.light}
                            size={32}
                        />
                    </button>
                </div>

                <div className='w-full h-full flex justify-center items-center'>
                    <Video url={videoUrl} height={"650"} />
                </div>

            </div>
        </div>
    )
}

export default VideoGallery